<template>
  <!-- 入仓登记 라벨 인쇄 영역(숨김) — 入仓登记 화면과 订单列表 已入仓 탭(재인쇄)이 같이 쓴다 -->
  <div :id="areaId" style="display:none">
    <div v-for="(l, i) in labels" :key="'il' + i" style="page-break-after:always;width:80mm;height:60mm;overflow:hidden">
      <inbound-label :row="l.row" :location="l.location" :waybill="l.waybill"></inbound-label>
    </div>
  </div>
</template>

<script>
import InboundLabel from './InboundLabel.vue';

export const LABEL_QTY_MAX = 200;

export default {
  name: 'InboundLabelPrint',
  components: { InboundLabel },
  props: {
    areaId: { type: String, default: 'inboundLabelPrintArea' }
  },
  data() {
    return { labels: [] };
  },
  methods: {
    // list: [{ row, location, qty, waybill? }] — 행마다 qty 장. waybill 은 입창 때 찍은 운송장(없으면 행에서 찾는다)
    print(list) {
      const labels = [];
      (list || []).forEach(it => {
        const n = Math.min(LABEL_QTY_MAX, Math.max(0, parseInt(it.qty) || 0));
        for (let k = 0; k < n; k++) labels.push({ row: it.row, location: it.location || '', waybill: it.waybill || '' });
      });
      if (!labels.length) {
        alert('没有要打印的标签(인쇄할 라벨이 없습니다)');
        return;
      }
      this.labels = labels;
      // 箱子标签과 같은 80×60mm 라벨지 설정. 출고형식 색 띠가 인쇄되게 color-adjust
      const css = '@page{size:80mm 60mm;margin:0}html,body{margin:0;padding:0}*{-webkit-print-color-adjust:exact;print-color-adjust:exact}svg{height:14mm;width:auto;max-width:100%}';
      this.$nextTick(() => {
        try {
          this.$htmlToPaper(this.areaId, { name: '_blank', autoClose: true, styles: ['data:text/css;charset=utf-8,' + encodeURIComponent(css)] });
        } catch (e) {
          console.error('入仓登记 라벨 인쇄 오류:', e);
          alert('打印失败(인쇄 실패): ' + e.message);
        }
        setTimeout(() => { this.labels = []; }, 2000);
      });
    }
  }
};
</script>
